import { render, staticRenderFns } from "./SchoolCourseDuration.vue?vue&type=template&id=381c40db&scoped=true&"
import script from "./SchoolCourseDuration.vue?vue&type=script&lang=js&"
export * from "./SchoolCourseDuration.vue?vue&type=script&lang=js&"
import style0 from "./SchoolCourseDuration.vue?vue&type=style&index=0&id=381c40db&prod&scoped=true&lang=less&"
import style1 from "./SchoolCourseDuration.vue?vue&type=style&index=1&id=381c40db&prod&lang=less&"
import style2 from "./SchoolCourseDuration.vue?vue&type=style&index=2&id=381c40db&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "381c40db",
  null
  
)

export default component.exports